import React from 'react'

const CareersBreadcrumb = () => {
  return (
    <div className="bg-primary-ink-100 px-4 py-5">
      <p className="text-center text-sm text-white lg:text-base">
        We prioritize candidate safety. Please be aware that official communication will only come from{' '}
        <span className="font-medium text-primary-green-85">@secureframe.com</span> email addresses.
      </p>
    </div>
  )
}

export default CareersBreadcrumb
